import * as React from 'react'
import { Icon } from '../icon'
import './input.scss'

interface InputProps {
  // @ https://bit.ly/2EAqROS
  type: 'text' | 'number' | 'range' | 'checkbox' | 'image' | 'url' | 'email' | 'search' // strict typing for ie10 supported input types
  placeholder?: string
  defaultValue?: string
  icon?: string
  alt?: string
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void
  classNames?: string
}

export class Input extends React.Component<InputProps>{
  inputRef: React.RefObject<HTMLInputElement> = React.createRef()

  render(): React.ReactNode {
    return (
      <div className={`input-container ${this.props.classNames || ''}`}>
        <input
          ref={this.inputRef}
          type={this.props.type}
          placeholder={this.props.placeholder}
          className="input-container__input"
          value={this.props.defaultValue}
          onChange={this.props.onChange}
          onKeyDown={this.props.onKeyDown}
        />
        <Icon className="input-container__icon" icon="search" />
      </div>
    )
  }
}
